import CryptoJS from 'crypto-js';

// Hashing function using SHA-256
// const hashKey = (key) => {
//   return CryptoJS.SHA256(key).toString(CryptoJS.enc.Hex);
// };
// import { Secret, Token } from 'fernet';
export function isArrayEmpty(arr) {
  try {
    if (Array.isArray(arr) && arr.length) {
      return false;
    }
    return true;
  } catch (error) {
    return true;
  }
}
export function debounce(func, timeout = 300) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, timeout);
  };
}

export const MAIN_FILTER = {
  select_lob: {
    name: 'Select LOB',
    slug: 'select_lob',
    is_value: false,
    value: null,
    visible: true
  },
  select_team: {
    name: 'Select Team',
    slug: 'select_team',
    is_value: false,
    value: null,
    visible: true
  },
  select_agent: {
    name: 'Select Agent',
    slug: 'select_agent',
    is_value: false,
    value: null,
    visible: true
  }
};

export function mergeFilterData(state, payload) {
  const { extra_filter, feature_filter, page_info, main_filter } = payload;
  return {
    extra_filter: { ...state?.extra_filter, ...extra_filter },
    feature_filter: { ...state?.feature_filter, ...feature_filter },
    page_info: { ...state?.page_info, ...page_info },
    main_filter: { ...state?.main_filter, ...main_filter }
  };
}

export const BG_GRADIENT = {
  '#FCECEC': ['#FF9696', '#DD1212'],
  '#FFF0D9': ['#F9F017', '#DD7312'],
  '#D9F2E8': ['#00FF89', '#2FA406']
};

export const CALL_STATUS = {
  Dialed: 'Dialed',
  'In-Progress': 'In-Progress',
  Ended: 'Ended'
};

export const getCallStatusBG = (value) => {
  if (value === CALL_STATUS.Dialed) {
    return BG_GRADIENT['#D9F2E8'];
  } else if (value === CALL_STATUS['In-Progress']) {
    return BG_GRADIENT['#FFF0D9'];
  } else {
    return BG_GRADIENT['#FCECEC'];
  }
};

export const SENTIMENT_STATUS = {
  POSITIVE: 'POSITIVE',
  NEGATIVE: 'NEGATIVE'
};
export const getSentimentBG = (value) => {
  if (value === CALL_STATUS.NEGATIVE) {
    return BG_GRADIENT['#FFF0D9'];
  } else if (value === CALL_STATUS.POSITIVE) {
    return BG_GRADIENT['#D9F2E8'];
  } else {
    return BG_GRADIENT['#FCECEC'];
  }
};

export function formatDateString(dateString) {
  const date = new Date(dateString);

  const year = date.getFullYear().toString().substr(-2);
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  const hours = date.getHours() % 12 || 12;
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const ampm = date.getHours() >= 12 ? 'PM' : 'AM';

  const formattedString = `${month}/${day}/${year} ${hours}.${minutes} ${ampm}`;

  return formattedString;
}

export function getTimeAgoOrDate(dateString) {
  const date = new Date(dateString);
  const now = new Date();

  const timeDifferenceInSeconds = Math.floor((now - date) / 1000);

  if (timeDifferenceInSeconds < 60) {
    return `${timeDifferenceInSeconds} sec ago`;
  } else if (timeDifferenceInSeconds < 3600) {
    const minutesAgo = Math.floor(timeDifferenceInSeconds / 60);
    return `${minutesAgo} min ago`;
  } else if (timeDifferenceInSeconds < 86400) {
    const hoursAgo = Math.floor(timeDifferenceInSeconds / 3600);
    return `${hoursAgo} hr ago`;
  } else if (timeDifferenceInSeconds < 604800) {
    // within 7 days (7 * 24 * 3600 seconds)
    const daysAgo = Math.floor(timeDifferenceInSeconds / 86400);
    return `${daysAgo} day ago`;
  } else {
    // Date was more than 7 days ago, return the actual date in the desired format
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return date.toLocaleDateString('en-US', options);
  }
}

export function getTimeFromDateString(dateString) {
  const date = new Date(dateString);

  const hours = date.getHours() % 12 || 12;
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const ampm = date.getHours() >= 12 ? 'PM' : 'AM';

  const formattedString = `${hours}.${minutes} ${ampm}`;

  return formattedString;
}

export const decryptData = (encryptedData) => {
  if (!encryptedData) {
    console.error('Encrypted data is undefined');
    return null;
  }

  try {
    // const secretKey = process.env.DATA_DECRYPT_KEY;
    const secretKey = process.env.REACT_APP_DATA_DECRYPT_KEY;
    // console.log('process.env', process.env);
    const key = CryptoJS.enc.Utf8.parse(secretKey);
    const decrypted = CryptoJS.AES.decrypt(encryptedData, key, { mode: CryptoJS.mode.ECB });
    const decryptedData = decrypted.toString(CryptoJS.enc.Utf8);
    return JSON.parse(decryptedData);
  } catch (error) {
    console.error('Error decrypting data:', error);
    return null;
  }
};

export const finalshow = (filters) => {
  const hasSelectedValues =
    filters &&
    Object?.entries(filters)?.some(([key, _el]) => {
      // console.log(key);
      key;
      if (Array.isArray(_el?.selected)) {
        return _el?.selected?.length > 0;
      } else if (Array?.isArray(_el)) {
        return _el.some((item) => {
          if (item?.selected) {
            if (item?.selected === true || item?.selected !== null) {
              return true;
            }
          }
          return false;
        });
      }
      return false;
    });

  return hasSelectedValues;
};
